var ko = require("knockout")
window.ko = ko;

var jquery = require("jquery")
window.jQuery = jquery;

jquery.noConflict();
require("jquery-mask-plugin")

require("../lib/ko-deferredcomputed")
require("../lib/ko-subscribeonce")
require("../lib/ko-binding-mask")

require("./helpers/polyfill");

var initSentry = require("./helpers/sentry").initSentry

var ViewModel = require("./viewmodels/ViewModel");
var Authenticator = require("./helpers/Authenticator");

var auth = new Authenticator('/cec/');
window.vm = new ViewModel();

window.reqwest = require("reqwest")
window.$ = {
  ajax: function (params) {
    window.reqwest(params);
  }
};

window.addEventListener('DOMContentLoaded', function () {
  initSentry();

  auth.checkLogin(function () {
    ko.applyBindings(window.vm);

    window.vm.init();

    document.getElementById('loggedinUser').addEventListener('mouseleave', function () {
      window.vm.userMenuHide();
    });

    document.getElementById('employeeMenu').addEventListener('mouseleave', function () {
      window.vm.userMenuHide();
    });

    window.addEventListener('resize', function () {
      window.vm.matchQueueTitleHeight();
    });
  });

});
